<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button slot="start" fill="clear" (click)="onBack()">Back</ion-button>
    <ion-title>{{ pageTitle }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (pageLoading) {
  <div class="page-content loading-state">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Loading collection request...</p>
  </div>
  } @else {
  <div class="page-content">
    <div class="section-card">
      <h3 class="section-title">Template</h3>
      <ion-item button [detail]="!isEditMode" lines="none" class="template-trigger" [disabled]="isEditMode"
        (click)="openTemplateSelect()">
        <ion-label>
          @if (selectedTemplate) {
          {{ selectedTemplate.purpose }}
          } @else {
          Select template
          }
        </ion-label>
      </ion-item>
    </div>

    <div class="section-card">
      <ion-item lines="none" class="toggle-item">
        <ion-toggle class="font-bold" [checked]="allowGroup"
          (ionChange)="allowGroup = $any($event).detail.checked">Allow
          Group</ion-toggle>
      </ion-item>

      @if (allowGroup) {
      <div class="flex flex-col gap-2">
        <div class="flex flex-row gap-2 items-center justify-between">
          <label class="field-label">Minimum Participants</label>
          <plus-minus [value]="minParticipants" (valueChange)="onMinParticipantsChange($event)" [min]="1"></plus-minus>
        </div>
        <div class="flex flex-row gap-2 items-center justify-between">
          <label class="field-label">Maximum Participants</label>
          <plus-minus [(value)]="maxParticipants" [min]="minParticipants"></plus-minus>
        </div>
      </div>


      }
    </div>

    <div class="section-card">
      <h3 class="section-title">Participant Details</h3>

      @for (i of participantSlots; track i) {
      @if (allowGroup || i === 0) {
      <div class="field-group">
        <label class="field-label">Participant {{ i + 1 }} – email or phone (optional)</label>
        <input type="text" [value]="getParticipantContact(i)" (input)="setParticipantContact(i, $any($event.target).value)"
          placeholder="Enter email or phone" class="field-input" />
        <ion-item lines="none" class="toggle-item">
          <ion-toggle [checked]="isParticipantAdmin(i)"
            (ionChange)="setParticipantAdmin(i, $any($event).detail.checked)">Admin</ion-toggle>
        </ion-item>
      </div>
      }
      }
      <p class="share-hint">If no email or phone is provided, the request will be accessible to anyone with the link.
      </p>
      @if (allowGroup && participantSlots.length > 1) {
      <p class="share-hint">Enter email or phone for each participant slot. Only that contact can fill that slot.</p>
      }

    </div>

    <div class="section-card">
      <h3 class="section-title">Webhook</h3>
      <div class="field-group">
        <label class="field-label">Webhook URL (optional)</label>
        <input type="url" [value]="webhookUrl" (input)="webhookUrl = $any($event.target).value"
          placeholder="https://example.com/webhook" class="field-input" />
      </div>
      @if (webhookUrl.trim()) {
      <div class="field-group">
        <label class="field-label">Webhook secret (optional)</label>
        <input type="text" [value]="webhookSecret" (input)="webhookSecret = $any($event.target).value"
          placeholder="Secret for signing payloads" class="field-input" />
      </div>
      <div class="field-group">
        <label class="field-label">Webhook identifier (optional)</label>
        <input type="text" [value]="webhookIdentifier" (input)="webhookIdentifier = $any($event.target).value"
          placeholder="Identifier for this webhook" class="field-input" />
      </div>
      }
      <p class="share-hint">We'll send a POST request to this URL when the collection request is completed or updated.
      </p>
    </div>

    <div class="section-card">
      <ion-accordion-group class="participant-accordion">
        <ion-accordion value="request-body-json">
          <ion-item slot="header" button detail="true" class="accordion-header">
            <ion-icon name="code-slash-outline"></ion-icon>
            <ion-label>View request body as JSON</ion-label>
          </ion-item>
          <div slot="content" class="accordion-content">
            <pre class="request-body-json" aria-label="Request body JSON">{{ requestBodyJson }}</pre>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>

    @if (error) {
    <p class="m-0 rounded-lg bg-red-50 px-3 py-2 text-sm text-gray-900">{{ error }}</p>
    }

    <super-button [title]="submitLabel" [isLoading]="loading" [action]="onSubmit">

      {{ submitLabel }}

    </super-button>
  </div>
  }
</ion-content>